'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'plug';
var width = 448;
var height = 512;
var aliases = [128268];
var unicode = 'f1e6';
var svgPathData = ['M48 112l352 0 0 112c0 97.2-78.8 176-176 176S48 321.2 48 224l0-112z', 'M120-32c4.4 0 8 3.6 8 8l0 120 192 0 0-120c0-4.4 3.6-8 8-8s8 3.6 8 8l0 120 104 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-24 0 0 112c0 103.4-81.7 187.6-184 191.8l0 88.2c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-88.2C113.7 411.6 32 327.4 32 224l0-112-24 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l104 0 0-120c0-4.4 3.6-8 8-8zM48 112l0 112c0 97.2 78.8 176 176 176s176-78.8 176-176l0-112-352 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPlug = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;